import { useCallback, useEffect, useRef } from "react";
import { bestaetigen as meBestaetigen } from "../me/index.js";
/** Die Fragen, die `bestaetigen()` von me-design baut, tragen dieses Kennzeichen. */
const FRAGE = "me-dialog[data-bestaetigen]";
function aktivesElement() {
    const aktiv = document.activeElement;
    return aktiv === null || aktiv === document.body ? null : aktiv;
}
export function useBestaetigung() {
    const offenRef = useRef(null);
    const bestaetigen = useCallback((frage) => {
        if (offenRef.current !== null)
            return Promise.resolve(false);
        return new Promise((aufloesen) => {
            const eintrag = { dialog: null, aufloesen };
            offenRef.current = eintrag;
            const fertig = (ja) => {
                if (offenRef.current === eintrag)
                    offenRef.current = null;
                aufloesen(ja);
            };
            eintrag.aufloesen = fertig;
            const vorher = new Set(document.querySelectorAll(FRAGE));
            const antwort = meBestaetigen({
                titel: frage.titel,
                ...(frage.text === undefined ? {} : { text: frage.text }),
                bestaetigenText: frage.bestaetigenText,
                gefahr: frage.gefaehrlich === true,
                an: frage.an === undefined ? aktivesElement() : frage.an,
            });
            // Der Helfer hängt die Frage im selben Aufruf ein — die neue ist die, die vorher fehlte.
            eintrag.dialog = Array.from(document.querySelectorAll(FRAGE))
                .find((d) => !vorher.has(d)) ?? null;
            void antwort.then(({ ok }) => { fertig(ok); }, () => { fertig(false); });
        });
    }, []);
    // Aushängen mit offener Frage: abgelehnt, und die Frage geht mit.
    useEffect(() => () => {
        const offen = offenRef.current;
        offenRef.current = null;
        if (offen === null)
            return;
        offen.aufloesen(false);
        const dialog = offen.dialog;
        if (dialog === null)
            return;
        if (dialog.isConnected && typeof dialog.schliessen === "function")
            dialog.schliessen();
        else
            dialog.remove();
    }, []);
    return { bestaetigen };
}
//# sourceMappingURL=useBestaetigung.js.map